import React__default, { useEffect } from 'react';
import { SuccessColored, InforOutlined, DeleteCircleColored } from '@teko/ds-icon';
import styled from '@emotion/styled';

const toastIcon = {
  success: /* @__PURE__ */ React__default.createElement(SuccessColored, {
    size: 30
  }),
  info: /* @__PURE__ */ React__default.createElement(InforOutlined, {
    size: 30
  }),
  warning: /* @__PURE__ */ React__default.createElement(InforOutlined, {
    size: 30
  }),
  error: /* @__PURE__ */ React__default.createElement(DeleteCircleColored, {
    size: 30
  })
};
const Toast = ({
  message,
  icon,
  placement = "middle",
  type,
  duration = 5e3,
  onClose,
  customStyle
}) => {
  useEffect(() => {
    let handle;
    if (duration) {
      handle = setTimeout(() => onClose == null ? void 0 : onClose(), duration);
    }
    return () => {
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, []);
  const positionClass = `teko-mobile-toast teko-mobile-toast-${placement}`;
  return /* @__PURE__ */ React__default.createElement(StyledToast, {
    className: positionClass,
    style: customStyle
  }, (icon || type) && /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-mobile-toast-icon"
  }, icon ? icon : type && toastIcon[type]), /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-mobile-toast-message"
  }, message));
};
const StyledToast = styled.div`
  &.teko-mobile-toast {
    display: flex;
    z-index: 1070;
    position: fixed;
    left: 50%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 70%;
    padding: 8px 16px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-break: break-word;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    transform: translate3d(-50%, -50%, 0);
    &.teko-mobile-toast-top {
      top: 20%;
    }
    &.teko-mobile-toast-middle {
      top: 50%;
    }
    &.teko-mobile-toast-bottom {
      top: 80%;
    }
    .teko-mobile-toast-icon {
      margin-bottom: 4px;
    }
  }
`;

export { Toast };
